import { render } from "./courseDetails.vue?vue&type=template&id=3a2b2890"
import script from "./courseDetails.vue?vue&type=script&lang=js"
export * from "./courseDetails.vue?vue&type=script&lang=js"

import "./courseDetails.vue?vue&type=style&index=0&id=3a2b2890&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__